/// <amd-module name="Search/Shared/Components/ExtendedSearchSection/ExtendedSearchSection" />
import * as React from "react";
import { IExtendedSearchSectionProps } from "./ExtendedSearchSection.Props";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { IExtendedSearchSectionSpec } from "Search/Shared/Base/Types";
import { WrappedComponent } from "VSS/Platform/Layout";
import { isFeatureFlagEnabled } from "VSS/Platform/Feature";

export interface IExtendedSearchSectionState {
    extendedSearchSectionDependencies?: string[];

    extendedSearchSectionComponent?: string;

    extendedSearchSectionFeatureState?: boolean;
}

export class ExtendedSearchSection extends React.Component<IExtendedSearchSectionProps, IExtendedSearchSectionState>{
    constructor(props: IExtendedSearchSectionProps) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element | null {
        return (
            !this.props.project && this.state.extendedSearchSectionFeatureState && this.state.extendedSearchSectionComponent ?
                <div className={this.props.className}>
                    <WrappedComponent
                        dependencies={this.state.extendedSearchSectionDependencies}
                        wrappedType={this.state.extendedSearchSectionComponent}
                        wrappedProps={{
                            defaultSearchText: this.props.defaultSearchText,
                            selectedTabId: this.props.selectedTabId
                        }} />
                </div>
                : null
        );
    }

    public componentDidMount(): void {
        this.props.selectedTabId.subscribe(this.updateSection);
        this.updateSection();
    }

    private updateSection = (): void => {
        const contributionService =
            this.props.pageContext.getService<IVssContributionService>("IVssContributionService");
        const contributions =
            contributionService.getContributionChildren("ms.vss-search-web.search-hub:content:pivots") || [];

        const selectedPivot = contributions
            .map(cid => contributionService.getContribution<IExtendedSearchSectionSpec>(cid))
            .filter(tab => tab && tab.id === this.props.selectedTabId.value)[0];

        if (selectedPivot) {
            const { extendedSearchSectionComponent, extendedSearchSectionDependencies, extendedSearchSectionFeatureFlag } = selectedPivot;
            this.setState({
                extendedSearchSectionComponent,
                extendedSearchSectionDependencies,
                extendedSearchSectionFeatureState: extendedSearchSectionFeatureFlag ? isFeatureFlagEnabled(this.props.pageContext, extendedSearchSectionFeatureFlag) : false
            });
        }
    }
}
